import parse from "html-react-parser";
import {IMAGE_URL} from "@/constants/general-constants";
import {ImageWithFallback} from "@/components";

export default function MainSliderCard({data = {}}) {

    const {title = "", banner = "", description = "", link_title = "", link = "", color = ""} = data;

    return (
        <section
            className="relative flex flex-col px-7 pt-[10.313rem] lg:pt-[11.348rem] h-[calc(100vh-1.563rem)] min-h-[817px] lg:min-h-[710px] rounded-b-[3.125rem]"
            style={{backgroundColor: color}}>
            <div
                className="relative flex-1 mb-9 lg:mb-0 lg:pr-[6.5rem] lg:pl-2.5 flex flex-col lg:flex-row items-center justify-center lg:justify-between">
                <div>
                    <div className="font-extrabold text-[1.75rem] text-center lg:text-start leading-[159%] lg:text-5xl lg:leading-[4.625rem] lg:max-w-[30rem]">
                        {parse(title || "<span></span>")}
                    </div>
                    <div className="text-justify mt-[1.625rem] lg:mt-12 text-sm lg:text-base text-pol-dark-800 leading-7 lg:max-w-[23.438rem] limit-line-3 lg:limit-line-none">
                        {parse(description || "<span></span>")}
                    </div>
                    <div className="text-center lg:text-start mt-7 lg:mt-14">
                        <a
                            rel="noopener noreferrer"
                            href={link}
                            className="btn-main font-semibold text-sm px-[1.063rem] py-[0.77rem]"
                        >
                            <p>
                                {link_title}
                                <i className="icon-arrow-left text-[.5rem] align-middle mr-8"/>
                            </p>
                        </a>
                    </div>
                </div>
                <div className="flex justify-center lg:block mt-10 lg:mt-0">
                    <div
                        className="relative w-[19.125rem] h-[19.125rem] lg:w-[32.375rem] lg:h-[32.375rem] lg:p-8 px-3 py-[1.125rem]">
                        {/*<div className="inset-auto absolute w-[15.938rem] h-[15.938rem] lg:w-[26.875rem] lg:h-[26.875rem] bg-white/10 rounded-full"/>*/}
                        <div className="w-full h-full relative">
                            <ImageWithFallback
                                alt={title}
                                src={IMAGE_URL + banner}
                                fill
                                className="object-contain"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="drop-shadow-[0_-4px_33px_rgba(100,29,255,0.22)] bg-white h-[1.625rem] absolute w-[70%] lg:w-[80%] right-14 -bottom-[1.625rem]"/>
        </section>
    )
}
